$(document).on('click', '.js-collection-filters-button', function() {
  $(document).find('.js-collection-filters').addClass('open');
});

$(document).on('click', '.js-collection-filters-back', function() {
  $(document).find('.js-collection-filters').removeClass('open');
});

setTimeout(function() {
  var order1 = false;
  var order2 = false;
  var order3 = false;

  $('.accordion-container').each(function() {
    if ($(this).css('order') === '1') {
      order1 = true
      $(this).find('.ac-q').trigger('click')
    }
    if ($(this).css('order') === '2') {
      order2 = true;
      $(this).find('.ac-q').trigger('click')
    }
    if ($(this).css('order') === '3') {
      order3 = true;
      $(this).find('.ac-q').trigger('click')
    }
  })

  $('.accordion-container').each(function(index) {
    if (index === 0 && order1 === false) {
      $(this).find('.ac-q').trigger('click')
    }
    if (index === 1 && order2 === false) {
      $(this).find('.ac-q').trigger('click')
    }
    if (index === 2 && order3 === false) {
      $(this).find('.ac-q').trigger('click')
    }
  })
}, 1000)
